import { Observable } from 'rxjs';

import { Group } from '@shure/cloud/shared/models/devices';

import {
	CreateGroupInput,
	DeleteGroupInput,
	MoveGroupInput,
	RenameGroupInput
} from '../api-instance-sys-api/graphql/generated/cloud-sys-api';

export type CreateGroupApiInput = CreateGroupInput;
export type DeleteGroupApiInput = DeleteGroupInput;
export type RenameGroupApiInput = RenameGroupInput;
export type MoveGroupApiInput = MoveGroupInput;

export interface GroupMutationResult {
	group: Group;
}

export abstract class GroupsApiService {
	public abstract groupsLoadingComplete$: Observable<boolean>;
	public abstract groupAdded$: Observable<Group>;
	public abstract groupRemoved$: Observable<string>;
	public abstract groupSnapshot$: Observable<Group>;
	public abstract suspended$: Observable<void>;

	public abstract createGroup(input: CreateGroupApiInput): Observable<GroupMutationResult>;
	public abstract deleteGroup(input: DeleteGroupApiInput): Observable<GroupMutationResult>;
	public abstract renameGroup(input: RenameGroupApiInput): Observable<GroupMutationResult>;
	public abstract moveGroup(input: MoveGroupApiInput): Observable<GroupMutationResult>;
}
